import React from 'react';
import { careerTrack } from '../../data/board';
import { SectionHeading } from '../SectionHeading';
export function CareerTrack() {
  return <section id="career" className="w-full bg-white py-20 lg:py-28" data-id="element-111" data-mp="3502j2aorr385">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-112" data-mp="3jwjrou5kq3r0">
        <SectionHeading title="Executive Career Track Record" intro="Mandates held, and what each one was accountable for delivering." data-id="element-113" data-mp="3ewfa10sxj2z7" />

        <ol className="mt-14 lg:pl-4" data-id="element-114" data-mp="3sudn82viktd4">
          {careerTrack.map((role, index) => <li key={role.title} className="relative grid grid-cols-1 gap-4 border-l border-line pb-12 pl-8 last:pb-0 lg:grid-cols-12 lg:gap-12 lg:pl-12" data-id="element-115" data-mp="3nwc1fa6pefxy" data-mpi={index}>
              <span className="absolute -left-[4.5px] top-2 h-2 w-2 rounded-full bg-gold-500" aria-hidden="true" data-id="element-116" data-mp="1iu1lrxye5dy" />
              <h3 className="font-display text-2xl font-semibold leading-snug text-navy-900 lg:col-span-5" data-id="element-117" data-mp="bfyo5svpo2va">
                {role.title}
              </h3>
              <p className="text-base leading-relaxed text-muted lg:col-span-7 lg:pt-2" data-id="element-118" data-mp="1b34bwzed5bfd">
                {role.mandate}
              </p>
              <span className="sr-only" data-id="element-119" data-mp="1k298i06d6uow">{`Role ${index + 1} of ${careerTrack.length}`}</span>
            </li>)}
        </ol>
      </div>
    </section>;
}